var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-box"},[_c('img',{attrs:{"src":_vm.$baseUrl+_vm.llll.logo,"alt":""}}),_c('span',[_vm._v("会员费用支付")]),_c('span',[_vm._v(_vm._s(_vm.payMoney)+"元")]),_c('button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],on:{"click":_vm.payFun}},[_vm._v("支付")])])
}
var staticRenderFns = []

export { render, staticRenderFns }